import React, { useEffect, useState } from 'react'
import { Row, Col, Table, Form, } from 'react-bootstrap'



import { useDispatch, useSelector } from 'react-redux'
import { fetchPaidCustomers } from '../actions/productActions'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { Link, useNavigate } from 'react-router-dom'


import { userLogoutAction } from '../actions/userActions'
import exportToExcel from '../utils/ExportToExcel'
import ToJalaali from '../utils/ToJalaali'
import jalaali from "jalaali-js"; // پکیج خودتان
import { BASE_URL } from '../constants/urlConstants'
import PersianText from '../components/PersianText'

function AbfaScreen() {

  const history = useNavigate()
  const dispatch = useDispatch()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  // const listPaidCustomers = useSelector(state => state.listPaidCustomer)
  // const { error, loading, paidCustomer } = listPaidCustomers
  const { error, loading, paidCustomer = [] } = useSelector(state => state.listPaidCustomer || {})


  // داده‌های اولیه برای دراپ‌دان‌ها
  const years = Array.from({ length: 11 }, (_, i) => 1400 + i); // 1400 تا 1410
  const months = Array.from({ length: 12 }, (_, i) => i + 1);
  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  
    // استیت‌های تاریخ شمسی (مقدار پیش‌فرض: امروز یا یک بازه خاص)
  const [startDate, setStartDate] = useState({ y: 1403, m: 1, d: 1 });
  const [endDate, setEndDate] = useState({ y: 1403, m: 12, d: 29 });
  
  const [selectedOption, setSelectedOption] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [selectedCode, setselectedCode] = useState(""); // ذخیره گزینه انتخاب‌شده
  const [message, setMessage] = useState('')

  const TE = "Invalid token specified: must be a string"

  useEffect(() => {
    if (error === TE) {
      dispatch(userLogoutAction());
      history('/login?redirect=/profile');
    }
    if (!userInfo) {
      history('/login')
    }
  }, [history, userInfo, dispatch, error])

  

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault()//صفحه ریلود نمیشود
    if (!selectedOption && !selectedCode) {
      setMessage('لطفا یک مورد را انتخاب کنید !')
    } else {
        // تبدیل تاریخ شمسی به میلادی برای ارسال به بک‌اِند
              const gStart = jalaali.toGregorian(parseInt(startDate.y), parseInt(startDate.m), parseInt(startDate.d));
              const gEnd = jalaali.toGregorian(parseInt(endDate.y), parseInt(endDate.m), parseInt(endDate.d));
      
              const startStr = `${gStart.gy}-${String(gStart.gm).padStart(2, '0')}-${String(gStart.gd).padStart(2, '0')}`;
              const endStr = `${gEnd.gy}-${String(gEnd.gm).padStart(2, '0')}-${String(gEnd.gd).padStart(2, '0')}`;
      
              const searchId = selectedOption || selectedCode;
      
              dispatch(fetchPaidCustomers(searchId, startStr, endStr));
              setMessage('');

      // setMessage('')
      // if (selectedOption) {
      //   dispatch(fetchPaidCustomers(selectedOption))
      // } else {
      //   dispatch(fetchPaidCustomers(selectedCode))
      // }
      setSelectedOption('')
      setselectedCode('')


    }
  }


  const tableData = paidCustomer.map((item, index) => ({
    "ردیف": index + 1,
    "کد رهگیری": item.track_code,
    "نام": item.customer.name,
    "امور": item.customer.area.name,
    "پک مربوطه": item.categoryKit,
    "تاریخ پرداخت": ToJalaali(item.paidAt),
    " آماده ارسال": ToJalaali(item.readyAt),
    "تاریخ تحویل": ToJalaali(item.deliveredAt),
    "عدم تحویل": ToJalaali(item.problemAt),
    "توضیحات": item.description
  }))


  const handlePrint = () => {
    window.print();
  };

  // کامپوننت داخلی برای ردیف‌های انتخاب تاریخ
      const DateSelector = ({ label, value, onChange }) => (
          <Col md={6} className="mb-3">
              <Form.Label className="fw-bold">{label}</Form.Label>
              <div className="d-flex gap-1">
                  <Form.Select size="sm" value={value.y} onChange={(e) => onChange({...value, y: e.target.value})}>
                      {years.map(y => <option key={y} value={y}>{y}</option>)}
                  </Form.Select>
                  <Form.Select size="sm" value={value.m} onChange={(e) => onChange({...value, m: e.target.value})}>
                      {months.map(m => <option key={m} value={m}>{m.toString().padStart(2, '0')}</option>)}
                  </Form.Select>
                  <Form.Select size="sm" value={value.d} onChange={(e) => onChange({...value, d: e.target.value})}>
                      {days.map(d => <option key={d} value={d}>{d.toString().padStart(2, '0')}</option>)}
                  </Form.Select>
              </div>
          </Col>
      );

  console.log(userInfo.name)
  console.log(paidCustomer)
  return (

    <div>
      {
        loading ? <Loader />
          : error ? <Message variant='danger' text={error} />
            : message ? <Message variant='danger' text={message} />
              : <></>
      }
      <p className='text-danger large mt-3'>گزارش تحویل :</p>
      
        {/* <form onSubmit={handleSubmit}> */}
        <form onSubmit={handleSubmit} className="bg-light p-3 rounded border mb-4">
          <Row align="center">
          
              <Col md={3} className='pt-3'>
               <Form.Check type="radio" label="پرداخت شده" name="option" value="1" checked={selectedOption === "1"} onChange={handleOptionChange} />
               <Form.Check type="radio" label="آماده ارسال" name="option" value="2" checked={selectedOption === "2"} onChange={handleOptionChange} />
               <Form.Check type="radio" label="تحویل شده" name="option" value="3" checked={selectedOption === "3"} onChange={handleOptionChange} />
               <Form.Check type="radio" label="اشکال در تحویل" name="option" value="4" checked={selectedOption === "4"} onChange={handleOptionChange} />
               <Form.Check type="radio" label="همه موارد" name="option" value="5" checked={selectedOption === "5"} onChange={handleOptionChange} />
               <Form.Check type="radio" label="پرداخت نشده" name="option" value="6" checked={selectedOption === "6"} onChange={handleOptionChange} />
                {/* <div>

                  <input
                    type="radio"
                    name="option"
                    value="1"
                    checked={selectedOption === "1"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    پرداخت شده
                  </label>
                </div>
                <div>

                  <input
                    type="radio"
                    name="option"
                    value="2"
                    checked={selectedOption === "2"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    آماده ارسال
                  </label>
                </div> */}

              </Col>
              {/* <Col md={3} className='pt-3'>

                <div>

                  <input
                    type="radio"
                    name="option"
                    value="3"
                    checked={selectedOption === "3"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    تحویل شده
                  </label>
                </div>
                <div>

                  <input
                    type="radio"
                    name="option"
                    value="4"
                    checked={selectedOption === "4"}
                    onChange={handleOptionChange}
                  /><label className='p-1'>
                    اشکال در تحویل
                  </label>
                </div>
              </Col> */}
              
              {/* {userInfo.name == "mina" ? (
              <Col md={3} className='pt-3'>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="5"
                        checked={selectedOption === "5"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        همه موارد
                      </label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        name="option"
                        value="6"
                        checked={selectedOption === "6"}
                        onChange={handleOptionChange}
                      /><label className='p-1'>
                        پرداخت نشده
                      </label>
                    </div>     
              </Col>
               ) : ""} */}

                <Col md={6}>
                                       <Row>
                                           <DateSelector label="از تاریخ:" value={startDate} onChange={setStartDate} />
                                           <DateSelector label="تا تاریخ:" value={endDate} onChange={setEndDate} />
                                       </Row>
                </Col>

                <Col md={3} className='border-end'>  
                 <Form.Group controlId='trackcode'>
                                            <Form.Label className="fw-bold">جستجو با کد رهگیری:</Form.Label>
                                            <Form.Control
                                                type='text'
                                                placeholder='مثلا 102030'
                                                value={selectedCode}
                                                onChange={(e) => { setselectedCode(e.target.value); setSelectedOption(""); }}
                                            />
                                        </Form.Group>  
              </Col>
            </Row>
            <Row>
              <div className="d-grid gap-2 d-md-block col-3 p-3">
                <button className="btn btn-primary" type="submit">نمایش</button>
              </div>
            </Row>
          
        </form>
      
      <Row>
        <Col>
          <img src={`${BASE_URL}/public/images/logo/exel-icon.png`} onClick={() => exportToExcel(tableData, "table-data")} alt="icon" className="icon"></img>

          <img src={`${BASE_URL}/public/images/logo/print-icon.png`} onClick={handlePrint} alt="icon" className="icon"></img>
        </Col>
      </Row>
      <Row>

        <Table className="table table-sm table-bordered table-warning table-striped table-hover" id="table-to-print">
          <thead>
            <tr className='table-warning'>
              <td className='table-warning text-danger'>ردیف</td>
              <td className='table-warning text-danger'>کد رهگیری</td>
              <td className='table-warning text-danger'>نام</td>
              <td className='table-warning text-danger'>امور</td>
              <td className='table-warning text-danger'>پک مربوطه</td>
              <td className='table-warning text-danger'>تاریخ پرداخت</td>
              <td className='table-warning text-danger'>آماده ارسال</td>
              <td className='table-warning text-danger'>تاریخ تحویل</td>
              <td className='table-warning text-danger'> عدم تحویل</td>
              <td className='table-warning text-danger'>توضیحات</td>
            </tr>
          </thead>
          <tbody>
            {paidCustomer.map((items, index) => (
              <tr className='table-warning'>
                <td className='table-warning'>{index + 1}</td>
                <td className='table-warning'>
                  <Link to={`/customer/${items._id}`}>
                    <PersianText> {items.track_code}</PersianText>
                  </Link>
                </td>
                <td className='table-warning'>{items.customer.name}</td>

                <td className='table-warning'>{items.customer.area.name}</td>

                <td className='table-warning'><PersianText>کیت شماره {items.categoryKit}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.paidAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.readyAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.deliveredAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{ToJalaali(items.problemAt)}</PersianText></td>
                <td className='table-warning'><PersianText>{items.description}</PersianText></td>
              </tr>
            ))}
          </tbody>
        </Table>

      </Row>

    </div>



  );
}

export default AbfaScreen
